<template>
  <div>
    <v-data-table
      :items="items"
      :headers="headers"
      :options.sync="options"
      :loading="loading"
      :footer-props="{
        'items-per-page-options': [30, 60, 90, -1]
      }"
    >
      <template v-slot:top="{ pagination }">
      <v-data-footer
        :pagination="pagination"
        :options.sync="options"
        :items-per-page-options="[30, 60, 90, -1]"
      ></v-data-footer>
      <v-divider></v-divider>
    </template>
      <template v-slot:item.company="{ item }">
        <v-chip label small>{{ item.company || '미등록' }}</v-chip>
      </template>
      <template v-slot:item.tags="{ item }">
        <v-chip v-for="tag in item.tags" :key="tag.id" label small class="ml-1">
          {{ tag.value }}
        </v-chip>
      </template>
      <template v-slot:item.download="{ item }">
        <day-download-btn :dayId="item.id"></day-download-btn>
      </template>
      <template v-slot:item.delete="{ item }">
        <v-btn icon @click="deleteDay(item)"><v-icon>mdi-delete</v-icon></v-btn>
      </template>
      <template v-slot:item.createdAt="{ item }">
        {{ $moment(item.createdAt).format('YY-MM-DD HH:mm:ss') }}
      </template>
    </v-data-table>

    <v-divider></v-divider>
  </div>
</template>

<script>
import { getDays, deleteDay } from '@/api'
import { getPaginationParams } from '@/utils'
import dayDownloadBtn from '@/components/day-download-btn'

export default {
  components: {
    dayDownloadBtn
  },
  data () {
    return {
      days: [],
      count: 0,
      loading: false,
      headers: [
        {
          text: '운행 날짜',
          value: 'date'
        },
        {
          text: '모뎀 번호',
          value: 'identityNo'
        },
        {
          text: '모델명',
          value: 'modelNo'
        },
        {
          text: '버전',
          value: 'version'
        },
        {
          text: '소속',
          value: 'company'
        },
        {
          text: '태그',
          value: 'tags',
          sortable: false
        },
        {
          text: '생성시간',
          value: 'createdAt'
        },
        {
          text: '다운로드',
          value: 'download',
          sortable: false
        },
        {
          text: '삭제',
          value: 'delete',
          sortable: false
        }
      ],
      options: {
        page: 1,
        itemsPerPage: 30
      }
    }
  },
  computed: {
    items () {
      console.log(this.days)
      return this.days.map(day => {
        const device = day.device

        const id = day.id
        const date = day.date
        const identityNo = device.identityNo
        const modelNo = device.modelNo
        const version = device.version
        const company = device.company ? device.company.name : ''
        const tags = device.tags
        const createdAt = day.createdAt

        return {
          id,
          date,
          identityNo,
          modelNo,
          version,
          company,
          tags,
          createdAt
        }
      })
    }
  },
  async beforeRouteEnter (to, from, next) {
    let page = parseInt(to.query.page, 10) || 1
    if (page < 1) page = 1

    const params = getPaginationParams(to, { itemsPerPage: 1000 })
    try {
      const { items, count } = await getDays(params)

      next(vm => {
        vm.days = items
        vm.count = count
        vm.pagination.page = page
      })
    } catch (err) {
      next()
    }
  },
  methods: {
    async deleteDay (item) {
      if (confirm(`${item.date} 운행기록을 삭제하시겠습니까? 이 작업은 되돌릴 수 없습니다.`)) {
        try {
          await deleteDay(item.id)
          await this.refresh()
        } catch (err) {
          alert(err.message)
        }
      }
    },
    async refresh () {
      this.loading = true
      try {
        const { items, count } = await getDays()

        this.days = items
        this.count = count
      } catch (err) {
        console.error(err.message)
      }
      this.loading = false
    },
    move (page) {
      if (page !== this.pagination.page) {
        this.pagination.page = page
        this.$router.push({ query: { page } })
      }
    }
  }
}
</script>
